import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Container, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import * as bomAction from '../Bom/store/BOMConfig.action';
import * as SubmitAction from './Store/Submit.action';
import SubmitLogsCard from './SubmitDownloadLogs/SubmitLogsCard';
import Loader from '../../../Components/Utility/Loader/Loader';

function DownloadLog() {
  const { timeZone } = Intl.DateTimeFormat().resolvedOptions();
  const dispatch = useDispatch();
  const reducer = useSelector((estate) => estate);
  const { devOrderId } = useParams();
  const {
    BOMConfigDetails: { productDetails },
    SubmitDownloadReducer,
    Users: { logInRights },
    UserDetails: { role, isSupplierLoggedIn },
  } = reducer;
  const { t } = useTranslation('common');

  const { DownloadLogData } = SubmitDownloadReducer;
  const [detailInfo, setDetailInfo] = useState(null);
  const [state, setState] = useState({
    downloadLogdata: [],
    loading: true,
    backButtonShow: true,
  });
  const { downloadLogdata, loading, backButtonShow } = state;
  useEffect(() => {
    let back_ButtonShow = true;
    if (role !== 'Admin') {
      logInRights?.forEach((log) => {
        back_ButtonShow = log?.submitTechPack || log?.downloadTechPack;
      });
    }
    setState((prev) => ({
      ...prev,
      backButtonShow: back_ButtonShow,
    }));
  }, [logInRights, role]);
  const emptyString = (obj) => {
    return obj || '';
  };
  useEffect(() => {
    setDetailInfo(productDetails);
  }, [productDetails]);

  useEffect(() => {
    const init = async () => {
      await dispatch(bomAction.fetchProductDetails(devOrderId));
      const obj = {
        devOrderId,
      };
      await dispatch(SubmitAction.getDownloadLogs(obj));
      setState((prev) => ({
        ...prev,
        loading: false,
      }));
    };
    init();
  }, [devOrderId, dispatch]);
  useEffect(() => {
    if (DownloadLogData?.length) {
      setState((prev) => ({
        ...prev,
        downloadLogdata: DownloadLogData,
      }));
    }
  }, [DownloadLogData]);

  const downloadFile = async (item) => {
    const data = {
      ...item,
      timeZone,
    };
    await dispatch(SubmitAction.downloadS3LogFiles(data, t));
    await dispatch(SubmitAction.downloadByUpdate({ ...data, logId: item._id }, t));
  };
  const deleteFiles = async (id) => {
    await dispatch(SubmitAction.deleteDownloadLogs(id, t));
    const obj = {
      devOrderId,
    };
    await dispatch(SubmitAction.getDownloadLogs(obj));
  };

  return (
    <>
      <div className="page-title-filter sticky">
        <div className="title-container">
          <span className="title">{t('DEVLOPMENT_ORDER.SUBMIT_DOWNLOAD.DOWN_LOGS.DOWNLOAD_LOG')} </span>
          &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;
          <span className="title">{emptyString(detailInfo?.number)}</span>{' '}
        </div>
        {backButtonShow && (
          <Link className="cursor-pointer text-dark text-decoration-none btn btn-white btn-back-lib" to={`/development-order/${devOrderId}/submit-download`}>
            {t('DEVLOPMENT_ORDER.SUBMIT_DOWNLOAD.DOWN_LOGS.BACK')}
          </Link>
        )}
      </div>
      <div className="d-flex justify-content-end m-3">
        {!isSupplierLoggedIn && (
          <Link className="cursor-pointer text-dark text-decoration-none btn btn-page-filter" to={`/development-order/${devOrderId}/submit-download-logs`}>
            {t('DEVLOPMENT_ORDER.SUBMIT_DOWNLOAD.DOWN_LOGS.SUBMIT')}
          </Link>
        )}

        {!isSupplierLoggedIn && (
          <Link className="cursor-pointer text-dark text-decoration-none btn btn-page-filter" to={`/development-order/${devOrderId}/download-logs`}>
            {t('DEVLOPMENT_ORDER.SUBMIT_DOWNLOAD.DOWN_LOGS.DOWNLOAD')}
          </Link>
        )}
      </div>

      <div>
        {loading ? (
          <Loader />
        ) : (
          <Container fluid>
            <Row>
              {downloadLogdata?.map((item, i) => (
                <SubmitLogsCard item={item} key={item?._id} index={i} downloadFile={downloadFile} deleteFiles={deleteFiles} />
              ))}
            </Row>
            {downloadLogdata?.length === 0 && (
              <div>
                <p className="mt-3 text-center"> {t('DEVLOPMENT_ORDER.SUBMIT_DOWNLOAD.DOWN_LOGS.NO_LOG_AVAILBLE')}</p>
              </div>
            )}
          </Container>
        )}
      </div>
    </>
  );
}

export default DownloadLog;
